var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 16.25H13.0374L14.5188 14.375L17.3337 18.75L19.1114 16.25H20.0003M10.667 6.24999H9.33366C7.8609 6.24999 6.66699 7.36928 6.66699 8.74999V23.75C6.66699 25.1307 7.8609 26.25 9.33366 26.25H22.667C24.1398 26.25 25.3337 25.1307 25.3337 23.75V8.74999C25.3337 7.36928 24.1398 6.24999 22.667 6.24999H21.3337M10.667 6.24999C10.667 7.6307 11.8609 8.75 13.3337 8.75H18.667C20.1398 8.75 21.3337 7.6307 21.3337 6.24999M10.667 6.24999C10.667 4.86928 11.8609 3.75 13.3337 3.75H18.667C20.1398 3.75 21.3337 4.86928 21.3337 6.24999",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalDoc);
export default __webpack_public_path__ + "static/media/medicalDoc.040003037f8230d504cfd808911af005.svg";
export { ForwardRef as ReactComponent };